import { FC } from 'react'

import { DayPropsInterface } from '../../models'
import DayContent from '../DayContent/DayContent'

interface DayProps extends DayPropsInterface {
    day: Date;
    outOfRange: boolean;
}

const Day: FC<DayProps> = ({
    day,
    outOfRange,
    leaveOfAbsences,
    absences,
    preferToWorkTimeSlots,
    unavailableToWorkTimeSlots,
    onResourceClick,
}) => (
    <div className={`day ${outOfRange ? 'day--out-of-range' : ''}`}>
        <DayContent
            day={day}
            leaveOfAbsences={leaveOfAbsences}
            absences={absences}
            preferToWorkTimeSlots={preferToWorkTimeSlots}
            unavailableToWorkTimeSlots={unavailableToWorkTimeSlots}
            onResourceClick={onResourceClick}
        />
    </div>
)

export default Day
